import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_get_released_footprint_event_by_inventoryCountIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { inventoryCountIds: number[] }): 
  Promise<{ result: { Id?: number, FootPrintEvent?: { ErrorMessage?: string, Notes?: string, FootPrintEventStatus?: { Id?: number, Name?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.inventoryCountIds)) {
      $missingRequiredInParams.push('\'inventoryCountIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { inventoryCountIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, FootPrintEvent?: { ErrorMessage?: string, Notes?: string, FootPrintEventStatus?: { Id?: number, Name?: string } } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.inventoryCountIds)) {
      $missingRequiredInParams.push('\'inventoryCountIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { inventoryCountIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, FootPrintEvent?: { ErrorMessage?: string, Notes?: string, FootPrintEventStatus?: { Id?: number, Name?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.inventoryCountIds)) {
      $missingRequiredInParams.push('\'inventoryCountIds\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      inventoryCountIds: number[]    }) {
        if(isNil($inParams.inventoryCountIds)) {
          return true; 
        }
      return false;
    }
}
